import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { userRoleTypes } from '../utils/userRoleTypes';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../data/atoms/utilsAtoms';

const useAuthentication = (role = userRoleTypes.ADMIN, skip = false) => {
	const userInfo = useAtomValue(userInfoAtom);
	const navigate = useNavigate();

	useEffect(() => {
		if (skip) return;

		if (userInfo.token == null || !userInfo.token) {
			toast.error('Please Login Again');
			navigate('/login');
		}

		if (userInfo.role !== role) {
			toast.error('user role does not match');
			navigate('/login');
		}
	}, [navigate, role, userInfo.token, userInfo.role, skip]);
};

export default useAuthentication;
